import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/apiaries'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
    },
    {
      path: '/register',
      name: 'register',
      component: () => import(/* webpackChunkName: "register" */ './views/Register.vue')
    },
    {
      path: '/password-reset',
      name: 'password_reset',
      component: () => import(/* webpackChunkName: "password-reset" */ './views/PasswordReset.vue')
    },
    {
      path: '/password-reset-send-mail',
      name: 'password_reset_send_mail',
      component: () => import('./views/PasswordResetSendMailResult.vue')
    },
    {
      path: '/apiaries',
      name: 'apiaries',
      component: () => import(/* webpackChunkName: "apiaries" */ './views/Apiaries.vue')
    },
    {
      path: '/apiary/create',
      name: 'apiary_create',
      component: () => import(/* webpackChunkName: "apiary-create" */ './views/ApiaryCreate.vue')
    },
    {
      path: '/apiary/edit/:id',
      name: 'apiary_edit',
      props: true,
      component: () => import(/* webpackChunkName: "apiary-edit" */ './views/ApiaryEdit.vue')
    },
    {
      path: '/apiary/:id',
      name: 'apiary',
      props: true,
      component: () => import(/* webpackChunkName: "apiary" */ './views/Apiary.vue')
    },
    {
      path: '/colony/create/:apiary',
      name: 'colony_create',
      props: true,
      component: () => import(/* webpackChunkName: "colony-create" */ './views/ColonyCreate.vue')
    },
    {
      path: '/colony/edit/:id/:apiary',
      name: 'colony_edit',
      props: true,
      component: () => import(/* webpackChunkName: "colony-edit" */ './views/ColonyEdit.vue')
    },
    {
      path: '/colony/:id/:apiary',
      name: 'colony',
      props: true,
      component: () => import(/* webpackChunkName: "colony" */ './views/Colony.vue')
    },
    {
      path: '/queen/create/:colony/:apiary',
      name: 'queen_create',
      props: true,
      component: () => import(/* webpackChunkName: "queen-create" */ './views/QueenCreate.vue')
    },
    {
      path: '/queen/edit/:id/:colony/:apiary',
      name: 'queen_edit',
      props: true,
      component: () => import(/* webpackChunkName: "queen-edit" */ './views/QueenEdit.vue')
    },
    {
      path: '/queen/:id/:colony/:apiary',
      name: 'queen',
      props: true,
      component: () => import(/* webpackChunkName: "queen" */ './views/Queen.vue')
    },
    {
      path: '/unite-colonies-or-remove-queen/:queen/:colony',
      name: 'unite_colonies_or_remove_queen',
      props: true,
      component: () => import(/* webpackChunkName: "unite_colonies_or_remove_queen" */ './views/UniteColoniesOrRemoveQueen.vue')
    },
    {
      path: '/unite-colonies-or-remove-queen2/:queen/:colony',
      name: 'unite_colonies_or_remove_queen2',
      props: true,
      component: () => import(/* webpackChunkName: "unite_colonies_or_remove_queen2" */ './views/UniteColoniesOrRemoveQueen2.vue')
    },
    {
      path: '/unite-colonies-or-remove-queen3/:colony',
      name: 'unite_colonies_or_remove_queen3',
      props: true,
      component: () => import(/* webpackChunkName: "unite_colonies_or_remove_queen3" */ './views/UniteColoniesOrRemoveQueen3.vue')
    },
    {
      path: '/unite-colonies/:colony',
      name: 'unite_colonies',
      props: true,
      component: () => import(/* webpackChunkName: "unite_colonies" */ './views/UniteColonies.vue')
    },
    {
      path: '/measure/create/:colony/:apiary/:type',
      name: 'measure_create',
      props: true,
      component: () => import(/* webpackChunkName: "measure-create" */ './views/MeasureCreate.vue')
    },
    {
      path: '/measure/edit/:id/:colony/:apiary',
      name: 'measure_edit',
      props: true,
      component: () => import(/* webpackChunkName: "measure-edit" */ './views/MeasureEdit.vue')
    },
    {
      path: '/rating/create/:colony/:apiary',
      name: 'rating_create',
      props: true,
      component: () => import(/* webpackChunkName: "rating-create" */ './views/RatingCreate.vue')
    },
    {
      path: '/rating/edit/:id/:colony/:apiary',
      name: 'rating_edit',
      props: true,
      component: () => import(/* webpackChunkName: "rating-edit" */ './views/RatingEdit.vue')
    },
    {
      path: '/rating/archive/:id/:apiary',
      name: 'rating_archive',
      props: true,
      component: () => import(/* webpackChunkName: "rating-archive" */ './views/RatingArchive.vue')
    },
    {
      path: '/note/create/:colony/:apiary',
      name: 'note_create',
      props: true,
      component: () => import(/* webpackChunkName: "note-create" */ './views/NoteCreate.vue')
    },
    {
      path: '/note/edit/:id/:colony/:apiary',
      name: 'note_edit',
      props: true,
      component: () => import(/* webpackChunkName: "note-edit" */ './views/NoteEdit.vue')
    }
  ]
})

router.beforeEach(function (to, from, next) {
  if (to.name === 'about' || to.name === 'login' || to.name === 'register' || to.name === 'password_reset' || to.name === 'password_reset_send_mail') {
    next()
  } else if (!store.getters['user/loggedIn']) {
    next({ name: 'login' })
  } else {
    next()
  }
})

export default router
